import React from 'react'
import BasicModal from '../BasicModal'
import ActivateChannelPasswordForm from '../../forms/ActivateChannelPasswordForm'

const ActivateChannelPasswordModal = ({ isVisible, data, onClose, onSubmit }) => {
   return (
      <BasicModal
         title='Активировать канал'
         isVisible={isVisible}
         onClose={onClose}
      >
         <ActivateChannelPasswordForm
            data={data}
            onSubmit={onSubmit}
         />
      </BasicModal>
   )
}

export default ActivateChannelPasswordModal